import { createBrowserWebview } from "@realestate.com.au/webview";
export var getNativeClient = function (searchParamsString) {
    var searchParams = new URLSearchParams(searchParamsString);
    var webview = createBrowserWebview({ searchParams: searchParams });
    return webview.client;
};
//# sourceMappingURL=nativeClient.js.map